/* eslint-disable quote-props */
const LOCALES = {
  'en': 'en-US',
  'au': 'en-AU',
  'be-nl': 'nl-BE',
  'be-fr': 'fr-BE',
  'br': 'pt-BR',
  'ca-en': 'en-CA',
  'ca-fr': 'fr-CA',
  'cz': 'cs-CZ',
  'dk': 'da-DK',
  'de': 'de-DE',
  'es': 'es-ES',
  'eu': 'en-NL',
  'fr': 'fr-FR',
  'hk': 'en-HK',
  'in': 'en-IN',
  'it': 'it-IT',
  'latam': 'es-AR',
  'hu': 'hu-HU',
  'asean': 'en-MY',
  'mx': 'es-MX',
  'ae': 'en-AE',
  'nl': 'nl-NL',
  'nz': 'en-NZ',
  'no': 'no-NO',
  'pl': 'pl-PL',
  'pt': 'pt-PT',
  'sg': 'en-SG',
  'fi': 'fi-FI',
  'se': 'sv-SE',
  'ch-de': 'de-CH',
  'za': 'en-ZA',
  'ch-fr': 'fr-CH',
  'ch-it': 'it-CH',
  'tr': 'tr-TR',
  'uk': 'en-GB',
  'ru': 'ru-RU',
  'cn': 'zh-CN',
  'tw': 'zh-TW',
  'jp': 'ja-JP',
  'kr': 'ko-KR',
};
module.exports = LOCALES;
// TODO: China lives outside of this pattern. Implementers will need to check the top-level domain for .com.cn
